<template>
  <div>
    <div class="noriceInfo" v-if="!eventId">
      <div class="title">
        <span>当前位置：&nbsp</span>
        <span>资讯中心</span>
        <span>></span>
        <span>展商中心</span>
        <span style="margin: 0 9px;">></span>
        <span>文件下载</span>
      </div>
      <div class="content">
        <ul>
          <li
            v-for="(item,index) in informationTypeList.slice( (pageIndex - 1) * pageSize, pageIndex * pageSize )"
            :key="index"
            @click="detail(item.id)"
          >
            <div class="leftDiv">
              {{ item.title }}
              <a :href="download(item)" style="color: #333333;">-下载</a>
            </div>
            <div class="rightDiv">{{ item.createDate }}</div>
          </li>
        </ul>
      </div>

      <el-pagination
        background
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-size="pageSize"
        layout="prev, pager, next, slot"
        :total="totalPage"
      >
        <el-input type="text" v-model="pageNum"></el-input>
        <el-button class="tz" @click="pageTz">跳转</el-button>
      </el-pagination>
    </div>

    <notice-details v-else @setEventId="setEventId"></notice-details>
  </div>
</template>
<script>
import noticedetails from "./EventsDetails";
export default {
  props: ["dataList"],
  components: {
    noticedetails,
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 2,
      pageNum: null,
      totalPage: 0,
      informationTypeList: [],
      eventId: null,
    };
  },
  mounted() {
    this.getInformationList();
  },
  methods: {
    currentChangeHandle(val) {
      this.pageIndex = val;
    },
    pageTz() {
      this.pageIndex = this.pageNum;
    },

    getInformationList() {
      this.$http({
        url: "getInformationList",
        method: "post",
        params: {
          type: "7",
        },
      })
        .then(({ data }) => {
          let { code, informationByTypeList } = data;
          if (code === 0) {
            informationByTypeList.forEach((res) => {
              res.createDate = res.createDate.substring(0, 10);
            });
            this.informationTypeList = informationByTypeList;
          }
        })
        .catch((err) => console.log(err));
    },

    download(currentLink) {
      return this.$http.adornUrl(currentLink.content);
    },

    detail(id) {
      // this.eventId = id;
    },

    setEventId() {
      this.eventId = null;
    },
  },
};
</script>
<style lang="scss">
.noriceInfo {
  .btn-prev,
  .btn-next {
    width: 52px;
    height: 32px;
    color: #eeeeee;
  }
  .el-icon-arrow-left:before {
    content: "上一页";
  }
  .el-icon-arrow-right:before {
    content: "下一页";
  }
  .el-pager {
    height: 32px;
    .active {
      background-color: #17327e !important;
    }
    .number {
      height: 100%;
      width: 32px;
      line-height: 32px;
      &:hover {
        background-color: #17327e !important;
        color: #ffffff !important;
      }
    }
  }
  .btn-quicknext {
    height: 32px;
    line-height: 32px !important;
  }
  .el-pagination {
    .el-input {
      width: 32px;
      height: 32px;
      .el-input__inner {
        border-radius: 0;
        width: 32px;
        height: 32px;
        padding: 0;
      }
    }
    .el-button {
      width: 54px;
      height: 32px;
      background-color: #eeeeee;
      color: #525252;
      margin-left: 8px;
      span {
        line-height: 32px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.noriceInfo {
  min-height: 1177px;
  background-color: #ffffff;
  box-shadow: -8px 0px 8px #fafafa, 0px -8px 8px #fafafa, 0px 8px 8px #fafafa;
  margin-bottom: 45px;
  .title {
    height: 43px;
    border-bottom: 1px solid #e5e5e5;
    line-height: 43px;
    padding-left: 17px;
    color: #b6b6b6;
    font-size: 12px;
    span:nth-child(3) {
      margin: 0 11px;
    }
  }
  .content {
    width: 857px;
    min-height: 958px;
    margin: 10px auto 21px;
    ul {
      list-style: square;
      text-indent: 16px;
      li {
        height: 59px;
        line-height: 59px;
        border-bottom: 1px solid #dfe1e1;
        // cursor: pointer;
        .leftDiv {
          float: left;
          font-size: 14px;
          color: #333333;
          //   width: 500px;
        }
        .rightDiv {
          float: right;
          font-size: 12px;
          color: #bbbbbb;
        }
      }
    }
  }
  .el-pagination {
    text-align: center;
  }
}
</style>